<template>
  <NotificationText v-bind="$props">
    <template #primary>
      Nachricht von <i>{{peerName}}</i>
    </template>
    <template #secondary>
      {{notification.data.text}}
    </template>

    <template #detail-content>
      <div v-if="invitation" class="text-center mb-2">
        <p class="mb-2">
          <i>{{peerName}}</i> hat dich in den Raum
          <i>{{invitation.room.name}}</i> eingeladen:
        </p>
        <v-btn :to="invitation.url" color="accent" depressed @click="markRead">
          Raum beitreten
        </v-btn>
      </div>
      <div v-else class="words">
        <strong class="font-weight-medium">Nachricht:</strong>&nbsp;
        <span v-for="(word, i) in words" :key="i">
          <template v-if="_isURL(word)">
            <a :href="word" target="_blank">{{word}}</a>
          </template>
          <template v-else>{{word}}</template>
        </span>
      </div>
    </template>
    <template #actions-prepend>
      <v-btn v-if="!actionsSecondary" color="accent" text small :disabled="!text" @click="copy">
        {{copyText}}
      </v-btn>

      <v-btn v-if="senderConnected" text small @click="answer">
        Antworten
      </v-btn>
    </template>
  </NotificationText>
</template>

<script>
  import PeerNotificationTextMixin from './peer-notification-text-mixin';

  import eventBus from '../../../assets/js/event-bus';
  import {isURL, copyTextToClipboard} from '../../../assets/js/utils';

  export default {
    name: 'PeerText',

    mixins: [
      PeerNotificationTextMixin
    ],

    data: () => ({
      invitation: null
    }),

    computed: {
      peer() {
        return this.notification?.data?.peer;
      },

      text() {
        return this.notification?.data?.text || '';
      },

      senderConnected() {
        if (this.peer) {
          return this.$store.getters['share/getPeer'](this.peer.id);
        }
        return false;
      },

      words() {
        return this.text.split(' ');
      },

      copyText() {
        if (this.invitation) {
          return 'Link kopieren';
        }
        return 'Kopieren';
      }
    },

    watch: {
      async text(href) {
        if (!this.detail) {
          return;
        }

        this.invitation = await new Promise(async (resolve) => {
          if (!isURL(href)) {
            return resolve(null);
          }

          const origin = location.origin.replace(/\//g, '\\/');
          const shortid = '[A-z0-9_-]{9}';
          const regex = `^${origin}\/invitation\/${shortid}$`;

          if (!href.match(regex)) {
            return resolve(null);
          }

          try {
            const id = href.substring(href.lastIndexOf('/') + 1);
            const {data: invitation} = await this.$api.post('InvitationGet', {id});
            return resolve({
              ...invitation,
              url: href.substring(location.origin.length) + '/accept'
            });
          } catch (error) {
            return resolve(null);
          }
        });
      }
    },

    mounted() {
      this.$options.watch.text.call(this, this.text);
    },

    methods: {
      async copy() {
        try {
          await copyTextToClipboard(this.text);
          eventBus.$emit('notifyUser', 'In die Zwischenablage kopiert');
        } catch (error) {
          eventBus.$emit('notifyUser', 'Nachricht konnte nicht in die Zwischenablage kopiert werden');
        }
      },

      answer() {
        this.markRead();
        eventBus.$emit('textRecipient', this.peer);
      },

      _isURL(string) {
        return isURL(string);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .words > span:not(:last-child)::after {
    content: " ";
    display: inline;
  }
</style>
